<template>
    <div>
        <input
            v-model="code"
            @click="selecteOrdre"
            type="text"
            class="inputClass"
            @keyup.enter="find_by_code"
        />
    </div>
</template>

<script>
import {usePaySectionStore} from "@/stores/PaySection.js";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";

export default {
    name: "InputPaySectionComponent",
    props: {
        selected: Array,
        object: Object,
        view: Boolean,
    },
    setup(props, {emit}) {
        const {$swal} = useTools();

        const paySectionStore = usePaySectionStore();

        const suggestion_dialog = ref(false);
        const suggestions = ref([]);
        const code = ref(null);

        function find_by_code() {
            const paySection = paySectionStore.paySections.find(p => p.code === code.value.toUpperCase());
            if (paySection) {
                add(paySection, false);
                save();
            } else {
                $swal.fire('Opps', 'Rubrique Introuvable', 'error')
                code.value = null;
            }
        }

        function save() {
            emit("save");
        }

        function selecteOrdre() {
            emit('selecteOrdre')
        }

        function add(item, result) {
            props.selected.push({
                ...item,
                result: result,
                position: result ? 'RESULT' : null
            });
            if (item.relations.length > 0) {
                item.relations.forEach((relation) => {
                    const relatedPaySection = paySectionStore.paySections.find((p) => p.code === relation.code);
                    if (relation.manualAdd) {
                        props.selected.push({
                            ...relatedPaySection,
                            result: true,
                            position: relation.position,
                        });
                    }
                });
            } else {
                paySectionStore.paySections.forEach((element) => {
                    if (element.formule) {
                        if (element.formule.includes(item.code)) {
                            const s = suggestions.value.find((e) => e.code === element.code);
                            if (!s) {
                                suggestions.value.push(element);
                            }
                        }
                    }
                });
                if (suggestions.value.length > 0) {
                    suggestion_dialog.value = true;
                }
            }
        }

        onMounted(() => {
            if (paySectionStore.paySections.length === 0)
                paySectionStore.findAll();
        })

        return {
            suggestion_dialog,
            suggestions,
            code,
            find_by_code,
            selecteOrdre
        }
    }
};
</script>

<style scoped>
.inputClass {
    width: 50px;
    border: 2px solid #009688;
}

.inputClass:focus {
    border: 2px solid #FF9800;
    outline: none;
}
</style>
